import { createSelector } from "reselect"

const yourTests = state => state.yourTests

export const getIsLoading = createSelector(yourTests, state => state?.isLoading)

export const getYourTests = createSelector(yourTests, state => state?.tests)
